import template from './spinner.pug';

const SpinnerComponent = {
  template,
};

export default SpinnerComponent;



// WEBPACK FOOTER //
// ./client/components/spinner/spinner.component.js